import style from 'containers/MyHealth/components/MyHealthResultsContext/Modals/Radiology/styles'
const themeStyles = colors => {
  const styles = {
    ...style(colors)
  }
  return styles
}

export default themeStyles
